import { render, staticRenderFns } from "./im-session-list.vue?vue&type=template&id=6506006f&scoped=true"
import script from "./im-session-list.vue?vue&type=script&lang=js"
export * from "./im-session-list.vue?vue&type=script&lang=js"
import style0 from "./im-session-list.vue?vue&type=style&index=0&id=6506006f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506006f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6506006f')) {
      api.createRecord('6506006f', component.options)
    } else {
      api.reload('6506006f', component.options)
    }
    module.hot.accept("./im-session-list.vue?vue&type=template&id=6506006f&scoped=true", function () {
      api.rerender('6506006f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-session-list.vue"
export default component.exports